import React from 'react';
import FlipBookViewer from './FlipBookViewer';

const PublicationViewer = ({ publicationId, token }) => {
  return <FlipBookViewer publicationId={publicationId} token={token} />;
};

export default PublicationViewer;
